import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { useSearchResultsContext } from "@/components/Search/SearchResults/context/searchResults.context";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    const { showFacets } = useSearchResultsContext();

    if (!showFacets) {
        return null;
    }

    return (
        <header
            className={cn(
                "tw:mb-3 tw:justify-between tw:items-center",
                "tw:sm:flex"
            )}
        >
            {children}
        </header>
    );
};

export { Base };
